/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { SkillFeedback, SkillFeedback$inboundSchema } from "./skillfeedback.js";
import {
  SkillFeedbackCounts,
  SkillFeedbackCounts$inboundSchema,
} from "./skillfeedbackcounts.js";
import {
  SkillFeedbackMetrics,
  SkillFeedbackMetrics$inboundSchema,
} from "./skillfeedbackmetrics.js";
import {
  SkillFeedbackTimelinePoint,
  SkillFeedbackTimelinePoint$inboundSchema,
} from "./skillfeedbacktimelinepoint.js";

/**
 * Outcome counts, collection metrics, a 30-day timeline, and a newest-first page of feedback for a skill.
 */
export type ListSkillFeedbackResult = {
  /**
   * All-time outcome counts for resolved feedback on a skill.
   */
  counts: SkillFeedbackCounts;
  feedback: Array<SkillFeedback>;
  /**
   * Feedback collection and suggestion conversion metrics for a skill.
   */
  metrics: SkillFeedbackMetrics;
  /**
   * Cursor for the next page; absent when exhausted.
   */
  nextCursor?: string | undefined;
  timeline: Array<SkillFeedbackTimelinePoint>;
};

/** @internal */
export const ListSkillFeedbackResult$inboundSchema: z.ZodMiniType<
  ListSkillFeedbackResult,
  unknown
> = z.pipe(
  z.object({
    counts: SkillFeedbackCounts$inboundSchema,
    feedback: z.array(SkillFeedback$inboundSchema),
    metrics: SkillFeedbackMetrics$inboundSchema,
    next_cursor: z.optional(z.string()),
    timeline: z.array(SkillFeedbackTimelinePoint$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listSkillFeedbackResultFromJSON(
  jsonString: string,
): SafeParseResult<ListSkillFeedbackResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSkillFeedbackResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSkillFeedbackResult' from JSON`,
  );
}
